<div class="wk8-audio-button" style="position: relative; user-select: none">
  <div class="waves" style="pointer-events: none">
    @for (wave of waves(); track $index) {
      <div
        class="audio-wave"
        style="position: absolute; width: 100%; height: 100%; inset: 0; border-radius: 100%; border: 4px solid white"
      ></div>
    }
  </div>
  <button class="button" style="display: block" (click)="play()">
    <img src="/assets/woordkr8/sprites/audio-button.png" (dragstart)="(false)" />
  </button>
</div>
